module.exports = __webpack_public_path__ + "static/img/game5.71dea5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game5.jpg
// module id = cE/+
// module chunks = 1